export abstract class Document {
    public static _type: string = 'Document';

    public _id?: string;
    public _?: string;
    public name?: string;

    public constructor(source?: any) {
        if (source) {
            this._id = source._id;
            this.name = source.name;
        }
    }

    public copy(source?: any): void {
        if (source) {
            this._id = source._id;
            this.name = source.name;
        }
    }
}
